// template/index.ts
import templateTop from "./template_1.jpg";
import template1 from "./template_1.jpg";
import template0 from "./template_0.jpg";
import template2 from "./template_2.jpg";
import template3 from "./template_3.jpg";
import template4 from "./template_4.jpg";
import template5 from "./template_5.jpg";
import template6 from "./template_6.jpg";
import template7 from "./template_7.jpg";
import template8 from "./template_8.jpg";
import template9 from "./template_9.jpg";
import template10 from "./template_10.jpg";
import template11 from "./template_11.jpg";
import template12 from "./template_12.jpg";
import template13 from "./template_13.jpg";
import template14 from "./template_14.jpg";
import template15 from "./template_15.jpg";
import template16 from "./template_16.jpg";
import template17 from "./template_17.jpg";
import template18 from "./template_18.jpg";
import template19 from "./template_19.jpg";
import template20 from "./template_20.jpg";
import template21 from "./template_21.jpg";
import template22 from "./template_22.jpg";
import template23 from "./template_23.jpg";
import template24 from "./template_24.jpg";
import template25 from "./template_25.jpg";
import template26 from "./template_26.jpg";
import template27 from "./template_27.jpg";
import template28 from "./template_28.jpg";
import template29 from "./template_29.jpg";
import template30 from "./template_30.jpg";
import template31 from "./template_31.jpg";
import template32 from "./template_32.jpg";
import template33 from "./template_33.jpg";

// テンプレート画像をマップで管理
const templateFiles = {
  0: template0,
  1: template1,
  2: template2,
  3: template3,
  4: template4,
  5: template5,
  6: template6,
  7: template7,
  8: template8,
  9: template9,
  10: template10,
  11: template11,
  12: template12,
  13: template13,
  14: template14,
  15: template15,
  16: template16,
  17: template17,
  18: template18,
  19: template19,
  20: template20,
  21: template21,
  22: template22,
  23: template23,
  24: template24,
  25: template25,
  26: template26,
  27: template27,
  28: template28,
  29: template29,
  30: template30,
  31: template31,
  32: template32,
  33: template33,
};

const Template = {
  top: templateTop,
  ...templateFiles,
};

export default Template;

// 個別エクスポート
export {
  templateTop,
  template0,
  template1,
  template2,
  template3,
  template4,
  template5,
  template6,
  template7,
  template8,
  template9,
  template10,
  template11,
  template12,
  template13,
  template14,
  template15,
  template16,
  template17,
  template18,
  template19,
  template20,
  template21,
  template22,
  template23,
  template24,
  template25,
  template26,
  template27,
  template28,
  template29,
  template30,
  template31,
  template32,
  template33,
};
